import { useEffect, useState } from "react";
import { Pencil, Trash2, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { adminInput, AdminField, SaveBar } from "./fields";

const EMPTY = { question: "", answer: "", order: 0 };

export const FaqsTab = () => {
  const [items, setItems] = useState(null);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/faqs").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editing === "new") await api.post("/admin/faqs", form);
      else await api.put(`/admin/faqs/${editing}`, form);
      setEditing(null);
      setForm(EMPTY);
      load();
    } finally { setSaving(false); }
  };

  const remove = async (f) => {
    if (!window.confirm("Delete this FAQ?")) return;
    await api.delete(`/admin/faqs/${f.id}`);
    load();
  };

  if (items === null) return <p className="text-sm text-charcoal/50">Loading…</p>;

  if (editing !== null) {
    return (
      <form onSubmit={save} className="max-w-2xl space-y-4 rounded-2xl border border-charcoal/10 bg-white p-7" data-testid="faq-form">
        <AdminField label="Question *">
          <input required className={adminInput} data-testid="faq-question-input" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} />
        </AdminField>
        <AdminField label="Answer *">
          <textarea required className={`${adminInput} min-h-[100px]`} data-testid="faq-answer-input" value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} />
        </AdminField>
        <AdminField label="Order">
          <input type="number" className={adminInput} value={form.order} onChange={(e) => setForm({ ...form, order: Number(e.target.value) })} />
        </AdminField>
        <SaveBar saving={saving} onCancel={() => { setEditing(null); setForm(EMPTY); }} />
      </form>
    );
  }

  return (
    <div>
      <button type="button" onClick={() => { setForm(EMPTY); setEditing("new"); }} data-testid="faq-new-button"
        className="mb-5 inline-flex items-center gap-2 rounded-full bg-charcoal px-5 py-2.5 text-xs font-bold text-gold">
        <Plus className="h-4 w-4" /> New FAQ
      </button>
      <div className="space-y-3">
        {items.map((f) => (
          <div key={f.id} className="flex items-center gap-4 rounded-xl border border-charcoal/10 bg-white px-5 py-4">
            <p className="min-w-0 flex-1 truncate text-sm font-semibold text-charcoal">{f.question}</p>
            <button type="button" onClick={() => { setForm({ question: f.question, answer: f.answer, order: f.order }); setEditing(f.id); }}
              data-testid={`faq-edit-${f.id.slice(0, 8)}`} className="rounded-full border border-charcoal/20 p-2 text-charcoal/60 hover:text-charcoal" aria-label="Edit FAQ">
              <Pencil className="h-4 w-4" />
            </button>
            <button type="button" onClick={() => remove(f)} data-testid={`faq-delete-${f.id.slice(0, 8)}`}
              className="rounded-full border border-red-200 p-2 text-red-500 hover:text-red-700" aria-label="Delete FAQ">
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
